// PlaceToPay (Evertec) WebCheckout — verify-session API client.
//
// Hits payment-gateway's REST endpoint to query a previously-created session.
// This is the trust boundary: never act on the redirect-back alone. Always
// verify the session server-side before applying the payment.
//
// URL is environment-driven via REACT_APP_PLACETOPAY_VERIFY_URL.
// Selfcare uses a runtime-config pattern (window._env_); see notes in
// createPlaceToPaySession.js for the full explanation.

function getEnv(key) {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return process.env[key];
}

const PLACETOPAY_VERIFY_URL = getEnv('REACT_APP_PLACETOPAY_VERIFY_URL');

/**
 * Verify a PlaceToPay session.
 *
 * @param {number} requestId         — the PlaceToPay session id returned by createSession
 * @param {object} [expected]        — optional but recommended: { amount, currency }
 *                                     If provided, payment-gateway will cross-check what
 *                                     the vendor charged vs what we expected. Mismatch flips
 *                                     `successful` to false (status='AMOUNT_MISMATCH').
 *                                     This protects against tampered amounts on the redirect.
 */
export default async function verifyPlaceToPaySession(requestId, expected) {
  if (!PLACETOPAY_VERIFY_URL) {
    throw new Error(
      'verifyPlaceToPaySession: REACT_APP_PLACETOPAY_VERIFY_URL is not set. ' +
      'Check helm_values/<tenant>/selfcare-ui.yaml.'
    );
  }
  const body = { requestId };
  if (expected && expected.amount != null && expected.currency) {
    body.expectedAmount = expected.amount;
    body.expectedCurrency = expected.currency;
  }
  const response = await fetch(PLACETOPAY_VERIFY_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    // credentials:'include' is supported because payment-gateway echoes the
    // specific Origin via its CrossOriginFilter (see createPlaceToPaySession.js).
    credentials: 'include',
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`verifyPlaceToPaySession HTTP ${response.status}: ${text}`);
  }
  return response.json();
}
